import { CellProps } from "react-table";
import ImageTextCell from "src/components/tables/cells/ImageTextCell";
import TextCell from "src/components/tables/cells/TextCell";
import { ProcurementRequestProducts } from "./purchase-order-types";

const useCreatePurchaseOrderTableColumns = () => {
  return [
    {
      Header: "Product Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: ({ row: { original } }: CellProps<ProcurementRequestProducts>) => (
        <ImageTextCell
          className="justify-center items-center"
          imageSrc={original?.products?.image}
          value={original?.products?.name}
        />
      ),
    },
    {
      Header: "Quantity",
      accessor: "quantity",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Unit Price",
      accessor: "unitPrice",
      className: "min-w-[150px]",
      Cell: ({ row: { original } }: CellProps<ProcurementRequestProducts>) => (
        <TextCell value={original.offeredPrice} />
      ),
    },
    {
      Header: "Total Price",
      accessor: "totalPrice",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
  ];
};

export default useCreatePurchaseOrderTableColumns;
